export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/css.a0784ef.svg";